"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var filter_list_1 = __importDefault(require("material-ui/svg-icons/content/filter-list"));
var view_column_1 = __importDefault(require("material-ui/svg-icons/action/view-column"));
var Checkbox_1 = __importDefault(require("../Checkbox"));
var Dialog_1 = __importDefault(require("material-ui/Dialog"));
var ExportButton_1 = __importDefault(require("../ExportButton"));
var Button_1 = __importDefault(require("../Button"));
var ConfirmButton_1 = __importDefault(require("../ConfirmButton"));
var Filters_1 = __importDefault(require("./Filters"));
var utils_1 = require("./utils");
var UniversalFilter_1 = __importDefault(require("../UniversalFilter"));
var columnsStyle = {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
};
var dialogStyle = {};
var ColumnCheckboxBase = function (_a) {
    var column = _a.column, index = _a.index, onToggleColumnVisibility = _a.onToggleColumnVisibility;
    return (react_1.default.createElement("label", { style: columnsStyle },
        react_1.default.createElement(Checkbox_1.default, { name: "" + column.field + index, onChange: onToggleColumnVisibility, value: column.visible !== false }),
        react_1.default.createElement("div", null, column.label)));
};
var ColumnCheckbox = recompose_1.compose(recompose_1.withHandlers({
    onToggleColumnVisibility: function (_a) {
        var columns = _a.columns, column = _a.column, rest = __rest(_a, ["columns", "column"]);
        return function (value) {
            var action = utils_1.actionHandler('COLUMNS', rest);
            action(columns.map(function (c) { return (c === column ? __assign({}, c, { visible: value }) : c); }));
        };
    },
}))(ColumnCheckboxBase);
var ColumnsDialogBase = function (_a) {
    var styles = _a.styles, onToggleColumns = _a.onToggleColumns, resetColumns = _a.resetColumns, hideAllColumns = _a.hideAllColumns, closeLabel = _a.closeLabel, resetLabel = _a.resetLabel, hideAllLabel = _a.hideAllLabel, rest = __rest(_a, ["styles", "onToggleColumns", "resetColumns", "hideAllColumns", "closeLabel", "resetLabel", "hideAllLabel"]);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { style: styles.columnList }, rest.columns.map(function (c, i) { return (react_1.default.createElement(ColumnCheckbox, __assign({ column: c, key: i, index: i }, rest))); })),
        react_1.default.createElement("div", { className: "buttons" },
            react_1.default.createElement(Button_1.default, { onClick: onToggleColumns, label: closeLabel }),
            react_1.default.createElement(Button_1.default, { onClick: resetColumns, label: resetLabel }),
            react_1.default.createElement(Button_1.default, { onClick: hideAllColumns, label: hideAllLabel }))));
};
var ColumnsDialog = recompose_1.compose(recompose_1.defaultProps({
    resetSettings: lodash_1.noop,
}), recompose_1.withHandlers({
    resetColumns: function (_a) {
        var columns = _a.columns, defaultColumns = _a.defaultColumns, resetSettings = _a.resetSettings, rest = __rest(_a, ["columns", "defaultColumns", "resetSettings"]);
        return function () {
            // removes old settings from storage
            // new settings will be stored on dialog close
            // the settings in grid wont be reset inplace (only the saved)
            resetSettings();
            var action = utils_1.actionHandler('COLUMNS', rest);
            action(defaultColumns);
        };
    },
    hideAllColumns: function (_a) {
        var columns = _a.columns, defaultColumns = _a.defaultColumns, resetSettings = _a.resetSettings, rest = __rest(_a, ["columns", "defaultColumns", "resetSettings"]);
        return function () {
            resetSettings();
            var action = utils_1.actionHandler('COLUMNS', rest);
            action(columns.map(function (c) { return (__assign({}, c, { visible: false })); }));
        };
    },
}))(ColumnsDialogBase);
var Caption = function (_a) {
    var adding = _a.adding, allowRestore = _a.allowRestore, showDeleted = _a.showDeleted, showDeactivated = _a.showDeactivated, filtering = _a.filtering, styles = _a.styles, openedFilters = _a.openedFilters, onToggleFilters = _a.onToggleFilters, onToggleColumns = _a.onToggleColumns, onResetSettings = _a.onResetSettings, addItem = _a.addItem, onDeleteItems = _a.onDeleteItems, onRestoreItems = _a.onRestoreItems, onDeactivateItem = _a.onDeactivateItem, onActivateItem = _a.onActivateItem, ActionBar = _a.ActionBar, checkedItems = _a.checkedItems, addLabel = _a.addLabel, deleteLabel = _a.deleteLabel, deleting = _a.deleting, columnsLabel = _a.columnsLabel, showDeletedLabel = _a.showDeletedLabel, activateLabel = _a.activateLabel, deactivateLabel = _a.deactivateLabel, showDeactivatedLabel = _a.showDeactivatedLabel, columnManager = _a.columnManager, openedColumnsDialog = _a.openedColumnsDialog, showCheckboxes = _a.showCheckboxes, reportLocation = _a.reportLocation, reportInput = _a.reportInput, reportUrlPrefix = _a.reportUrlPrefix, exportLabel = _a.exportLabel, sort = _a.sort, order = _a.order, page = _a.page, pageSize = _a.pageSize, resetSettings = _a.resetSettings, enableUniversalFilter = _a.enableUniversalFilter, setUniversalFilter = _a.setUniversalFilter, universalFilter = _a.universalFilter, changeUniversalFilterValueOnEnter = _a.changeUniversalFilterValueOnEnter, enableUniversalFilterClear = _a.enableUniversalFilterClear, loading = _a.loading, rest = __rest(_a, ["adding", "allowRestore", "showDeleted", "showDeactivated", "filtering", "styles", "openedFilters", "onToggleFilters", "onToggleColumns", "onResetSettings", "addItem", "onDeleteItems", "onRestoreItems", "onDeactivateItem", "onActivateItem", "ActionBar", "checkedItems", "addLabel", "deleteLabel", "deleting", "columnsLabel", "showDeletedLabel", "activateLabel", "deactivateLabel", "showDeactivatedLabel", "columnManager", "openedColumnsDialog", "showCheckboxes", "reportLocation", "reportInput", "reportUrlPrefix", "exportLabel", "sort", "order", "page", "pageSize", "resetSettings", "enableUniversalFilter", "setUniversalFilter", "universalFilter", "changeUniversalFilterValueOnEnter", "enableUniversalFilterClear", "loading"]);
    return adding || deleting || filtering || ActionBar || columnManager ? (react_1.default.createElement("caption", { style: styles.caption },
        enableUniversalFilter && (react_1.default.createElement(UniversalFilter_1.default, { value: universalFilter, onChange: setUniversalFilter, changeValueOnEnter: changeUniversalFilterValueOnEnter, enableClear: enableUniversalFilterClear, loading: loading })),
        react_1.default.createElement("div", { style: styles.buttonBar },
            adding && react_1.default.createElement(Button_1.default, { primary: true, label: addLabel, onMouseDown: addItem, style: { marginRight: 5 } }),
            deleting && showCheckboxes && (react_1.default.createElement(ConfirmButton_1.default, { label: deleteLabel, disabled: checkedItems.length < 1, onClick: onDeleteItems, style: { marginRight: 5 } })),
            filtering && react_1.default.createElement(Button_1.default, { icon: react_1.default.createElement(filter_list_1.default, null), onClick: onToggleFilters, style: { marginRight: 5 } }),
            columnManager && (react_1.default.createElement(Button_1.default, { icon: react_1.default.createElement(view_column_1.default, null), label: columnsLabel, onClick: onToggleColumns, style: { marginRight: 5 } })),
            reportLocation && (react_1.default.createElement(ExportButton_1.default, { exportLabel: exportLabel, location: reportLocation, urlPrefix: reportUrlPrefix, input: __assign({}, reportInput, { params: {
                        filter: __spread(rest.filters, lodash_1.get(reportInput, 'params.filters', [])),
                        sort: sort,
                        order: order,
                        page: page,
                        pageSize: pageSize,
                    } }) })),
            allowRestore && showCheckboxes && (react_1.default.createElement(ConfirmButton_1.default, { label: rest.restoreLabel, disabled: checkedItems.length < 1, onClick: onRestoreItems, style: { marginRight: 5 } })),
            showDeleted && (react_1.default.createElement("label", { style: { display: 'flex', alignItems: 'center' } },
                react_1.default.createElement(Checkbox_1.default, { checkboxStyle: { height: 36 }, name: "allowDeleted", onChange: rest.setShowDeleted, value: !!rest.allowDeleted }),
                showDeletedLabel)),
            showDeactivated && (react_1.default.createElement("label", { style: { display: 'flex', alignItems: 'center', marginLeft: 16 } },
                react_1.default.createElement(Checkbox_1.default, { checkboxStyle: { height: 36 }, name: "allowDeactivated", onChange: rest.setShowDeactivated, value: !!rest.allowDeactivated }),
                showDeactivatedLabel)),
            showDeactivated && showCheckboxes && lodash_1.get(checkedItems, '[0].active') === true && (react_1.default.createElement(ConfirmButton_1.default, { label: deactivateLabel, disabled: checkedItems.length !== 1, onClick: onDeactivateItem, style: { marginRight: 5 } })),
            showDeactivated && showCheckboxes && lodash_1.get(checkedItems, '[0].active') === false && (react_1.default.createElement(ConfirmButton_1.default, { label: activateLabel, disabled: checkedItems.length !== 1, onClick: onActivateItem, style: { marginRight: 5 } })),
            ActionBar && react_1.default.createElement(ActionBar, __assign({ checkedItems: checkedItems }, rest))),
        openedFilters && react_1.default.createElement(Filters_1.default, __assign({}, rest)),
        react_1.default.createElement(Dialog_1.default, { modal: false, open: openedColumnsDialog, onRequestClose: onToggleColumns, style: dialogStyle },
            react_1.default.createElement(ColumnsDialog, __assign({ onToggleColumns: onToggleColumns, onResetSettings: resetSettings, styles: styles }, rest))))) : null;
};
exports.default = recompose_1.compose(utils_1.withStyles, recompose_1.withHandlers({
    onToggleFilters: utils_1.actionHandler('OPENED_FILTERS'),
    onToggleColumns: utils_1.actionHandler('COLUMN_DIALOG'),
    onDeleteItems: function (_a) {
        var checkedItems = _a.checkedItems, deleteItems = _a.deleteItems, dispatch = _a.dispatch;
        return function () {
            deleteItems(checkedItems, dispatch);
        };
    },
    onRestoreItems: function (_a) {
        var checkedItems = _a.checkedItems, restoreItems = _a.restoreItems, dispatch = _a.dispatch;
        return function () {
            restoreItems(checkedItems, dispatch);
        };
    },
    onDeactivateItem: function (_a) {
        var checkedItems = _a.checkedItems, deactivateItem = _a.deactivateItem, dispatch = _a.dispatch;
        return function () {
            deactivateItem(checkedItems, dispatch);
        };
    },
    onActivateItem: function (_a) {
        var checkedItems = _a.checkedItems, activateItem = _a.activateItem, dispatch = _a.dispatch;
        return function () {
            activateItem(checkedItems, dispatch);
        };
    },
}))(Caption);
//# sourceMappingURL=Caption.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/Caption.js
// module id = 2024
// module chunks = 0